/**
 * `VITE_BOOT_RETRY_BASE_MS` / `VITE_BOOT_RETRY_MAX_MS` — optional overrides for
 * `TouchscreenProvider`'s boot retry backoff. Useful locally when the API sits behind a slow
 * remote DB and the default 2s-doubling-to-30s backoff retries faster than the previous attempt
 * even finishes. Unset (or invalid) values fall back to the provider's own defaults.
 */
export function readBootRetryEnv(): { retryBaseMs?: number; retryMaxMs?: number } {
  return {
    retryBaseMs: parsePositiveInt(import.meta.env.VITE_BOOT_RETRY_BASE_MS),
    retryMaxMs: parsePositiveInt(import.meta.env.VITE_BOOT_RETRY_MAX_MS),
  };
}

function parsePositiveInt(value: string | undefined): number | undefined {
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}
